module.exports = __webpack_public_path__ + "img/close-icon.88f2e34c.svg";